import React, { useState } from 'react'
import atoms from '../../../atoms'
import molecules from '../../../molecules'
import { RiDeleteBin6Line } from "react-icons/ri";
import { FiEdit } from "react-icons/fi";
import service from '../../../../api/services'
import { useToasts } from 'react-toast-notifications';
import { checkPermissionsInArray } from '../../../../constants/utils';
import { AllPermissions } from '../../../../constants/permissions';
const { Search, Button, Table, Input } = atoms
const { ConfirmationModal, CreateModal } = molecules

const Index = ({ setSearch, productTypeListing, getProductTypeListing }: any) => {
    const { addToast } = useToasts();
    const [handleDeleteModal, setHandleDeleteModal] = useState<boolean>(false)
    const [createModal, setCreateModal] = useState<boolean>(false)
    const [isEdit, setIsEdit] = useState<boolean>(false)
    const [productTypeValues, setProductTypeValues] = useState<any>({ name: '', code: '', percentage: '', product_type_initials: '' })
    const [selectedId, setSelectedId] = useState<string>('')
    const [errors, setErrors] = useState<any>({})
    const columns = [
        { name: 'Product Type', selector: (row: any) => row.name, sortable: true, minWidth: '20%' },
        { name: 'Product Type Initials', selector: (row: any) => row.product_type_initials, minWidth: '20%' },
        { name: 'HSN Code', selector: (row: any) => <>{ row.hsn_code}</>, sortable: true, minWidth: '10%' },
        { name: 'GST (%)', selector: (row: any) => <>{row.gst_percentage + '%'}</>, sortable: true, minWidth: '10%' },
        { name: 'Action', selector: (row: any) => row.action, minWidth: '30%' },

    ]
    const handleSubmit = async () => {
        const isValid = validate();
        if (isValid) {
            const payload = {
                name: productTypeValues.name,
                hsn_code: productTypeValues.code,
                gst_percentage: productTypeValues.percentage,
                product_type_initials: productTypeValues.product_type_initials

            }
            try {
                if (isEdit) {
                    // for update product type values
                    const response = await service.productData.updateProductTypeService(selectedId, payload)
                    if (response.status === 200) {
                        setCreateModal(false)
                        addToast('Product type updated successfully', {
                            appearance: 'success',
                            autoDismiss: true,
                            autoDismissTimeout: 3000,
                        });
                    }
                } else {
                    // for Create product type values
                    const response = await service.productData.createProductTypeService(payload)
                    if (response.status === 201) {
                        setCreateModal(false)
                        addToast('Product type added successfully', {
                            appearance: 'success',
                            autoDismiss: true,
                            autoDismissTimeout: 3000,
                        });
                    }
                }
            } catch (error: any) {
                console.log("error", error);
                addToast(error.response.data.message, {
                    appearance: 'error',
                    autoDismiss: true,
                    autoDismissTimeout: 3000,
                });
            }
            getProductTypeListing()
            setProductTypeValues({
                name: '',
                code: '',
                percentage: '',
                product_type_initials: '',
            })
            setIsEdit(false)
        }
    }
    const _handleDelete = (id: string) => {
        setSelectedId(id)
        setHandleDeleteModal(true)
    }
    const handleDeleteType = async () => {
        try {
            const response = await service.productData.deleteProductTypeService(selectedId)
            if (response.status === 200) {
                setHandleDeleteModal(false)
                addToast('Product type deleted successfully', {
                    appearance: 'success',
                    autoDismiss: true,
                    autoDismissTimeout: 3000,
                });
            }
        } catch (error: any) {
            console.log("error", error);
            setHandleDeleteModal(false)
            addToast(error.response.data.message, {
                appearance: 'error',
                autoDismiss: true,
                autoDismissTimeout: 3000,
            });
        }
        getProductTypeListing()
    }

    const _handleEdit = async (id: string) => {
        setSelectedId(id)
        handleProductTypeValues(id)
    }
    const handleProductTypeValues = async (id: string) => {
        setIsEdit(true)
        try {
            const response = await service.productData.getProductTypeByIdService(id)
            let resData = response.data.data
            if (response.status === 200) {
                setProductTypeValues({
                    name: resData?.name,
                    code: resData?.hsn_code,
                    percentage: resData?.gst_percentage,
                    product_type_initials: resData?.product_type_initials
                })
                setCreateModal(true)
            }
        } catch (error: any) {
            console.log("error", error);
            addToast(error.response.data.message, {
                appearance: 'error',
                autoDismiss: true,
                autoDismissTimeout: 3000,
            });
        }
    }
    const _handleClose = () => {
        setCreateModal(!createModal)
        setProductTypeValues({
            name: '',
            code: '',
            percentage: '',
            product_type_initials: ''
        })
        setIsEdit(false)
    }
    const handleChange = (name: string, value: string) => {
        setProductTypeValues({ ...productTypeValues, [name]: value })
        setErrors((prevErrors: any) => ({ ...prevErrors, [name]: "" }));
    }
    const validationRules: any = {
        name: {
            required: true,
        },
        product_type_initials: {
            required: true,
        },
        code: {
            required: true,
        },
        percentage: {
            required: true,
        },

    };
    const validate = () => {
        let newErrors: any = {};
        for (const field in validationRules) {
            if (validationRules.hasOwnProperty(field)) {
                if (validationRules[field]?.required && !productTypeValues[field]) {
                    newErrors[field] = "This field is required.";
                }
            }
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    return (
        <div>
            <div>
                <div className="row align-items-center">
                    <div className="col-6">
                        <Search searchCallBack={(e: string) => { setSearch(e) }} />
                    </div>
                    {checkPermissionsInArray(AllPermissions.Product_Type_Add) && <div className="col-6 text-end">
                        <Button name={'Create Product Type'}
                            onClick={() => setCreateModal(!createModal)}
                        />
                    </div>}
                </div>
            </div>
            <div>
                <Table
                    columns={columns}
                    data={productTypeListing?.data?.map((item: any) => {
                        return ({
                            ...item,
                            action: <div style={{ overflow: 'unset', textOverflow: 'unset' }}>
                                {checkPermissionsInArray(AllPermissions.Product_Type_Edit) && <Button className="table-edit-button fs-14 fw-400"
                                    onClick={() => _handleEdit(item.id)}>
                                    <div className='d-flex align-items-center'>
                                        <FiEdit />
                                        <span className='ms-2 mb-0'>Edit</span>
                                    </div>
                                </Button>}
                                {checkPermissionsInArray(AllPermissions.Product_Type_Delete) && <Button className="table-delete-button fs-14 fw-400 ms-3"
                                    onClick={() => _handleDelete(item.id)}>
                                    <div className='d-flex align-items-center'>
                                        <RiDeleteBin6Line />
                                        <span className='ms-2 mb-0'>Delete</span>
                                    </div>
                                </Button>}
                            </div>
                        })
                    })}
                />
            </div>
            {handleDeleteModal && <ConfirmationModal
                show={handleDeleteModal}
                handleConfirmItem={() => handleDeleteType()}
                onHide={() => setHandleDeleteModal(!handleDeleteModal)}
                message={'delete this Product Type'} />}

            {createModal && <CreateModal
                show={createModal}
                header={`${isEdit ? 'Update' : 'Create'} Product Type`}
                handleSubmit={handleSubmit}
                submitBtnText={`${isEdit ? 'Update' : 'Create'} Product Type`}
                onHide={() => _handleClose()}
            >
                <div>
                    <form>
                        <div className="row">
                            <div className="col-6">
                                <Input
                                    type="text"
                                    className="form-control"
                                    id="exampleInputEmail1"
                                    placeholder="Enter Product Type"
                                    onChange={(e: any) => handleChange("name", e.target.value)}
                                    defaultValue={productTypeValues.name}
                                    label='Product Type Name'
                                    errors={errors.name}
                                />
                            </div>
                            <div className="col-6">
                                <Input
                                    type="text"
                                    className="form-control"
                                    id="exampleInputEmail1"
                                    placeholder="Example (S for Sunglass)"
                                    onChange={(e: any) => handleChange("product_type_initials", e.target.value)}
                                    defaultValue={productTypeValues.product_type_initials}
                                    label='Product Type Initials'
                                    errors={errors.product_type_initials}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-6 mt-25">
                                <Input
                                    type="text"
                                    className="form-control"
                                    id="exampleInputEmail1"
                                    placeholder="Enter HSN Code"
                                    onChange={(e: any) => handleChange("code", e.target.value)}
                                    defaultValue={productTypeValues.code}
                                    label='HSN Code'
                                    errors={errors.code}
                                />
                            </div>
                            <div className="col-6 mt-25">
                                <Input
                                    type="number"
                                    className="form-control"
                                    id="exampleInputEmail1"
                                    placeholder="GST Percentage"
                                    onChange={(e: any) => handleChange("percentage", e.target.value)}
                                    defaultValue={productTypeValues.percentage}
                                    label='GST Percentage (%)'
                                    errors={errors.percentage}
                                />
                            </div>
                        </div>
                    </form>
                </div>
            </CreateModal>}
        </div>
    )
}

export default Index